"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommercetoolsGrant = void 0;
var scopes_1 = require("./scopes");
/**
 * Holds the details of the grant returned from commercetools in response
 * to an authorisation API related request:
 * https://docs.commercetools.com/api/authorization
 */
var CommercetoolsGrant = /** @class */ (function () {
    /**
     * Create a new grant from grant data received back from commercetools.
     */
    function CommercetoolsGrant(data) {
        /**
         * The access token string needed when making requests to commercetools. If this
         * was generated by a customer logging in, then this is used by commercetools
         * to identify the customer.
         */
        this.accessToken = '';
        /**
         * The duration of the access token in seconds (typically 48 hours)
         */
        this.expiresIn = 0;
        /**
         * This is the expiry date/time of the access token. This is calculated based
         * on the `expiredIn` property, and as such may be very slightly after the
         * internal commercetools expiry date (due to the time involved to receive
         * and process the response.
         */
        this.expiresAt = new Date();
        /**
         * List of permission scopes. This will also include the `anonymous_id` when
         * generating an anonymous customer token, or the `customer_id` when logging
         * in as an existing customer.
         */
        this.scopes = [];
        this.accessToken = data.access_token;
        this.expiresIn = data.expires_in;
        this.scopes = scopes_1.scopeRequestStringToArray(data.scope);
        this.anonymousId = this.extractKeyFromScope('anonymous_id', data.scope);
        this.customerId = this.extractKeyFromScope('customer_id', data.scope);
        // This sets the `expiresAt` property to the calculated Date when the grant is due to expire.
        this.expiresAt = new Date(new Date().getTime() + 1000 * data.expires_in);
        // When a grant is refreshed, we don't get back a new token,
        // so we keep hold of the old one unless one is explicitly provided.
        if ('refresh_token' in data && data.refresh_token) {
            this.refreshToken = data.refresh_token;
        }
    }
    /**
     * Calculates whether the grant is due to expire within a given number of
     * seconds. This is useful when deciding if the expiry date/time is close
     * enough to warrant pro-active renewal, rather than waiting for expiry.
     */
    CommercetoolsGrant.prototype.expiresWithin = function (refreshIfWithinSecs) {
        var cutoff = new Date().getTime() + refreshIfWithinSecs * 1000;
        return this.expiresAt.getTime() < cutoff;
    };
    /**
     * Given a scope string (as returned from commercetools), this method
     * extracts the value of the associated with the given key. Used for
     * retrieving the anonymous id and customer id from the scope string.
     */
    CommercetoolsGrant.prototype.extractKeyFromScope = function (key, scope) {
        if (!scope || !key) {
            return undefined;
        }
        var parts = scope === null || scope === void 0 ? void 0 : scope.split(' ');
        if (!Array.isArray(parts) || parts.length === 0) {
            return undefined;
        }
        var item = parts.find(function (part) { return part.slice(0, key.length + 1) === key + ":"; });
        if (item) {
            return item.slice(key.length + 1);
        }
        return undefined;
    };
    return CommercetoolsGrant;
}());
exports.CommercetoolsGrant = CommercetoolsGrant;
//# sourceMappingURL=CommercetoolsGrant.js.map